import request from '@/utils/http';

const getList = async (params) => request({
  method: 'get',
  url: 'get-list',
  params,
});
const getBpList = async (params) => request({
  method: 'get',
  url: 'get-bp-list',
  params,
});
const getInfo = async (params) => request({
  method: 'get',
  url: 'get-info',
  params,
});

const getReservedSeats = async (params) => request({
  method: 'get',
  url: 'get-reserved-seats',
  params,
});

export default {
  getList,
  getInfo,
  getReservedSeats,
	getBpList
};
